import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { List } from '@mui/material';

import SidebarItem from '@shared/SidebarItem/SidebarItem';

import { useTheme } from '../theme';

import { isRouteSelected } from '../Account/utils';
import { Route, UserInfo } from '../Account/types';

import { concatPassengerNames } from '../utils';

interface Props {
	routes: Route[];
	selectedRoute: string;
	userInfo: UserInfo;
}

const Sidebar: React.FunctionComponent<Props> = ({ routes, selectedRoute, userInfo }) => {
	const { Sidebar: css } = useTheme('Sidebar');

	const { t } = useTranslation('Account');

	const title = useMemo(
		() =>
			!!userInfo?.firstName && !!userInfo?.lastName
				? concatPassengerNames({ lastName: userInfo.lastName, firstName: userInfo.firstName })
				: t('My cabinet'),
		[userInfo]
	);

	return (
		<List
			className={css.sidebar}
			disablePadding
			classes={{
				root: css.root
			}}
		>
			<div className={css.title}>{title}</div>
			{routes.map(route => (
				<SidebarItem key={route.title} route={route} isSelected={isRouteSelected(route, selectedRoute)} />
			))}
		</List>
	);
};

export default Sidebar;
